
import { Button } from "@/components/ui/button";
import type { Database } from "@/integrations/supabase/types";

export type SupportedLanguage = Database["public"]["Enums"]["supported_language"];

interface LanguageSelectorProps {
  selectedLanguage: SupportedLanguage;
  onLanguageChange: (language: SupportedLanguage) => void;
}

export const LanguageSelector = ({
  selectedLanguage,
  onLanguageChange,
}: LanguageSelectorProps) => {
  const languages = [
    { code: "en", label: "English" },
    { code: "sv", label: "Svenska" },
    { code: "ar", label: "العربية" },
    { code: "ti", label: "ትግርኛ" },
    { code: "fa", label: "فارسی" },
    { code: "prs", label: "دری" },
    { code: "so", label: "Soomaali" },
    { code: "uk", label: "Українська" },
  ];

  return (
    <div className="flex flex-wrap justify-center gap-2" dir="ltr">
      {languages.map((lang) => (
        <Button
          key={lang.code}
          variant={selectedLanguage === lang.code ? "default" : "outline"}
          onClick={() => onLanguageChange(lang.code as SupportedLanguage)}
          className="w-20 h-8 text-xs"
          size="sm"
        >
          {lang.label}
        </Button>
      ))}
    </div>
  );
};
